/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useSignal } from '@preact/signals-react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useBeforeUnload } from 'react-router-dom';
import {
  CampaignReportsHeader,
  CampaignReportsChart,
  AppPanelCampaignReports,
  TableCampaignReports,
} from 'components';
import { campaignReportsActions } from 'store/actions';

export function CampaignReports() {
  // const [isLoading, setIsLoading] = useState(false);
  const timePeriod = useSelector((state) => state.manageCampaigns.selectedDateRange);
  const dateRangeName = useSelector((state) => state.manageCampaigns.dateRangeName);

  const dateFrom$ = useSignal(timePeriod.from);
  const dateTo$ = useSignal(timePeriod.to);
  const dateRangeName$ = useSignal(dateRangeName);

  const { cmp_id } = useParams();

  const dispatch = useDispatch();

  useBeforeUnload(() => {
    sessionStorage.setItem('state', 'refresh');
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      if (sessionStorage.getItem('state') === 'refresh') {
        //console.log('do nothing');
        // TO-DO set events
      } else {
        // console.log('remove store');
        dispatch(campaignReportsActions.clearState());
        dispatch(campaignReportsActions.clearFilters());
      }
      sessionStorage.setItem('state', 'initial');
    };
  }, []);

  return (
    <div style={{ minWidth: '1160px' }}>
      <CampaignReportsHeader
        dateFrom$={dateFrom$}
        dateTo$={dateTo$}
        dateRangeName$={dateRangeName$}
      />
      <CampaignReportsChart dateFrom$={dateFrom$} dateTo$={dateTo$} />
      <AppPanelCampaignReports />
      <TableCampaignReports dateFrom$={dateFrom$} dateTo$={dateTo$} />
    </div>
  );
}
